import createReducer from "../createReducer";
import { addFiltering } from "../common/Filtering";
import { addColumnFilters } from "../common/ColumnFilters";

import { SUPPRESS_SUCCESS_GROWL, EXISTING_CREATIVES_AD_TYPE_LIST } from "utils/constants";
import { escapeUnderscoreForAPI } from "utils/common";

const EXISTING_CREATIVES_ACTIONS = {
	LOAD_EXISTING_CREATIVES_AJAX: "LOAD_EXISTING_CREATIVES_AJAX",
	LOAD_EXISTING_CREATIVES_SUCCESS: "LOAD_EXISTING_CREATIVES_SUCCESS",
	LOAD_EXISTING_CREATIVES_ERROR: "LOAD_EXISTING_CREATIVES_ERROR",
};

export function loadCreatives(libraryId, formattedExistingSizes) {
	return (dispatch, getState) => {
		let state = getState();
		let { filterInfo = {} } = state.existingCreatives;
		const params = { ...filterInfo };

		params.advancedFilter = `all(not_in(adType,${EXISTING_CREATIVES_AD_TYPE_LIST.join(',')}),is_null(conceptID))`;

		if(formattedExistingSizes?.length){
			params.advancedFilter = `all(not_in(adType,${EXISTING_CREATIVES_AD_TYPE_LIST.join(',')}),is_null(conceptID),not_in(placementSize,${formattedExistingSizes.join(',')}))`;
		}

		if (params.searchTerm) {
			params.searchTerm = escapeUnderscoreForAPI(filterInfo.searchTerm);
		}

		return dispatch({
			type: EXISTING_CREATIVES_ACTIONS.LOAD_EXISTING_CREATIVES_AJAX,
			meta:SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `creative-libraries/${libraryId}/creatives`,
				params,
				success: EXISTING_CREATIVES_ACTIONS.LOAD_EXISTING_CREATIVES_SUCCESS,
				error: EXISTING_CREATIVES_ACTIONS.LOAD_EXISTING_CREATIVES_ERROR,
			},
		});
	};
}

const initialState = {
	isLoaded: false,
};

export const handlers = {
	[EXISTING_CREATIVES_ACTIONS.LOAD_EXISTING_CREATIVES_AJAX]: initLoading,
	[EXISTING_CREATIVES_ACTIONS.LOAD_EXISTING_CREATIVES_SUCCESS]: initCreativeList,
	[EXISTING_CREATIVES_ACTIONS.LOAD_EXISTING_CREATIVES_ERROR]: initLoadingError,
};

export function initLoading(state, action){
	return {
		...state,
		isLoaded: false,
	};
}

export function initCreativeList(state, action){
	return {
		...state,
		isLoaded: true,
		error: null,
		...action.payload.data,
	};
}

export function initLoadingError(state, action){
	return {
		...state,
		isLoaded: true,
		error: action.payload.data,
	};
}

let reducerConfig = {
	typeRoot: "EXISTING_CREATIVES",
	actionTypes: EXISTING_CREATIVES_ACTIONS,
	actionCreators: {
		loadCreatives,
	},
	...initialState,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, { sort:"id:ASC" });
reducerConfig = addColumnFilters(reducerConfig, {});


export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const Existing = reducerConfig.actionCreators;
